import { useState, useEffect, Suspense, lazy } from 'react'; 
import { useRouter } from 'next/router';
import { useAppState } from '../context/AppState';
import classes from '../styles/Page.module.scss';

export const PdfIframe = ({ src }) => (
    <iframe
      src={`${src}#toolbar=0&navpanes=0&scrollbar=0`}
      title="MTN Terms and Conditions"
      frameBorder="0"
      allowFullScreen
    />
);
const LazyPdfIframe = lazy(() => 
  import('./mtn-privacy-policy') 
    .then(module => ({ default: module.PdfIframe }))
);

const Legal = () => {
  const router = useRouter();
  
  const { language, country } = useAppState(); 
  
  const [isComponentMounted, setIsComponentMounted] = useState(false); 
  const defaultPdfUrl = "/MTN Cameroon - MTN One Privacy Notice (1).pdf";
  let pdfSource = defaultPdfUrl; 

  useEffect(() => {
    setIsComponentMounted(true);
  }, []);

  const handleGoBack = () => {
    router.back(); 
  };
  
  if (country && language) {
    
    const lang = language.toLowerCase();
    const ctry = country.toLowerCase();

    const pdfMap = {
      'en_cm': defaultPdfUrl,
      'fr_cm': '/MTN Cameroon - Politique de confidentialité (MTN One Privacy Policy - French).pdf',
      'en_ci': '/MTN CI - MTN One Privacy Notice.pdf',
      'fr_ci': '/MTN CI - Avis de confidentialité - (Privacy Notice - French) (1).pdf',
    };
    
    const key = `${lang}_${ctry}`;
    if (pdfMap[key]) {
      pdfSource = pdfMap[key];
    } else {
      pdfSource = defaultPdfUrl;
      console.warn(`No specific PDF found for key: ${key}. Using default PDF.`);
    }
  }

  const pageTitle = `MTN Legal Document: ${country?.toUpperCase() || 'Country'} (${language?.toUpperCase() || 'Language'})`;

  return (
    <div className={classes.oPageHome}>
      <div className={classes.oContent}>
        <h1 className={`${classes.aPageTitle}`}>
          <span
            onClick={handleGoBack}
            className={classes.backIcon}
            role="button"
            aria-label="Go back"
          >
            &#8592;
          </span>
          {pageTitle}
        </h1>
        
        {isComponentMounted && (
            <div className={classes.iframeContainer}>
                {/* Use the fixed LazyPdfIframe and pass the dynamic source */}
                <Suspense fallback={<div>Loading legal document...</div>}>
                    <LazyPdfIframe src={pdfSource} />
                </Suspense>
            </div>
        )}
      </div>
    </div>
  );
};

export default Legal;